var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEnOut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4687",
    "data-name": "Group 4687",
    transform: "translate(-233 -113)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_4604",
    "data-name": "Rectangle 4604",
    width: 15,
    height: 15,
    rx: 2,
    transform: "translate(233 113)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16036",
    "data-name": "Path 16036",
    d: "M1.386-3.159h3.45a.375.375,0,0,0,.4-.381.375.375,0,0,0-.4-.381H1.809V-6.256H4.666a.372.372,0,0,0,.4-.377.37.37,0,0,0-.4-.377H1.809V-9.188H4.836a.375.375,0,0,0,.4-.381.375.375,0,0,0-.4-.381H1.386a.4.4,0,0,0-.424.438V-3.6A.4.4,0,0,0,1.386-3.159ZM6.7-3.036a.4.4,0,0,0,.419-.438V-8.416H7.16l3.572,5.1a.505.505,0,0,0,.489.278A.433.433,0,0,0,11.7-3.5V-9.522a.4.4,0,0,0-.419-.438.4.4,0,0,0-.419.438v4.961h-.042L7.254-9.678a.514.514,0,0,0-.489-.282c-.292,0-.479.141-.479.438v5.992A.442.442,0,0,0,6.7-3.036Z",
    transform: "translate(234.168 126.998)",
    fill: "#f7f7f7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnOut);
export default __webpack_public_path__ + "static/media/EnOut.f3281dc774b25b9dc5c2382e9cb8bd15.svg";
export { ForwardRef as ReactComponent };